import React from "react";
import './FooterBar.css';
import SocialMediaBar from "../social-media/SocialMediaBar";
import { Link } from "react-router-dom";
import logo from '../../../assets/colorfuel-cropped-logo.png';

const FooterBar = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer">
            <div className="footer-container">
                <div className="footer-grid">
                    <div className="footer-brand">
                        <Link to="/" className="footer-logo-link">
                            <img src={logo} alt="ColorFuel Logo" className="footer-logo" />
                            <span className="brand-name">ColorFuel</span>
                        </Link>
                        <p className="brand-tagline">
                            Exploring the intersection of art, technology, and digital ownership.
                        </p>
                        <div className="footer-contact">
                            <a href="mailto:contact@colorfuel.art" className="contact-email">contact@colorfuel.art</a>
                        </div>
                    </div>

                    <div className="footer-nav">
                        <h4 className="footer-title">Explore</h4>
                        <ul className="footer-links">
                            <li><Link to="/">Home</Link></li>
                            <li><Link to="/discover">Discover</Link></li>
                            <li><Link to="/3dgallery">3D Gallery</Link></li>
                            <li><Link to="/about">About Us</Link></li>
                        </ul>
                    </div>

                    <div className="footer-legal-links">
                        <h4 className="footer-title">Legal</h4>
                        <ul className="footer-links">
                            <li><Link to="/terms">Terms of Service</Link></li>
                            <li><Link to="/privacy">Privacy Policy</Link></li>
                        </ul>
                    </div>

                    <div className="footer-social">
                        <h4 className="footer-title">Connect</h4>
                        <SocialMediaBar />
                    </div>
                </div>

                <div className="footer-bottom">
                    <div className="footer-divider"></div>
                    <div className="footer-bottom-content">
                        <p className="copyright">
                            © {currentYear} ColorFuel. All rights reserved.
                        </p>
                        <p className="footer-disclaimer">
                            By connecting your wallet, you agree to our{' '}
                            <Link to="/terms">Terms of Service</Link> and <Link to="/privacy">Privacy Policy</Link>.
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default FooterBar;
